import { useCallback } from 'react';
import { useI18n } from '@namespace/i18n';
import { useNotifications } from '@namespace/notifications';
import { formatErrorMessage } from '../../utils';

const WITHDRAW_SUCCESS_MSG = 'balance.withdraw.successMessage';

export const useWithdrawHandlers = () => {
  const { t } = useI18n();
  const { errorNotification, successNotification } = useNotifications();
  const withdrawSuccessMsg = t(WITHDRAW_SUCCESS_MSG);
  const getErrorMsg = useCallback(
    (code: string) => t(formatErrorMessage(code)),
    [t]
  );

  const handleSuccess = useCallback(
    async ({ showMsg = true, resetAmount = () => {} }) => {
      if (showMsg) {
        successNotification(withdrawSuccessMsg);
      }
      resetAmount();
    },
    [successNotification, withdrawSuccessMsg]
  );

  const handleError = useCallback(
    (errorCode: string) => {
      errorNotification(getErrorMsg(errorCode));
    },
    [errorNotification, getErrorMsg]
  );

  return {
    handleSuccess,
    handleError
  };
};
